module.exports = __webpack_public_path__ + "static/img/电子影像1.e71a79ea.png";